
var $ = require("jquery");

export function fixedHeader() {

    var $body = $('body');
    var $header = $('header');
    var isAlternativeMenu = $header.hasClass('alternate-menu');
    var $window = $(window);

    $(window).on('scroll', () => {

        if ($window.scrollTop() > 0) {
            $body.addClass('fixed-header');

            if (isAlternativeMenu == true)
                $body.css('padding-top', $header.height() + 'px');
        } else {
            $body.removeClass('fixed-header');

            if (isAlternativeMenu == true)
                $body.css('padding-top', '0');
        }
    })
}